__turbopack_context__.v({
  "error": "ToastView-module__ErBK3W__error",
  "expand": "ToastView-module__ErBK3W__expand",
  "fadeIn": "ToastView-module__ErBK3W__fadeIn",
  "iconWrapper": "ToastView-module__ErBK3W__iconWrapper",
  "iconWrapperInfo": "ToastView-module__ErBK3W__iconWrapperInfo",
  "info": "ToastView-module__ErBK3W__info",
  "label": "ToastView-module__ErBK3W__label",
  "largeToast": "ToastView-module__ErBK3W__largeToast",
  "smallToast": "ToastView-module__ErBK3W__smallToast",
  "styledToast": "ToastView-module__ErBK3W__styledToast",
  "success": "ToastView-module__ErBK3W__success",
  "toastIcon": "ToastView-module__ErBK3W__toastIcon",
  "toasts": "ToastView-module__ErBK3W__toasts",
  "xIcon": "ToastView-module__ErBK3W__xIcon",
});
